// assertUnreachable is for use with exhaustive switch statements
export const assertUnreachable = (msg: string, v: never): never => {
  throw new Error(`${msg}: ${v}`)
}
